import { render } from "./OrderAddView.vue?vue&type=template&id=31a59f39&ts=true"
import script from "./OrderAddView.vue?vue&type=script&lang=ts"
export * from "./OrderAddView.vue?vue&type=script&lang=ts"

import "./OrderAddView.vue?vue&type=style&index=0&id=31a59f39&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__